export default {
  SOURCE_LOCALE_REGEXP: /(?:\/([a-zA-Z]{2}(?:-[a-zA-Z]{2})?))?\/[\w-]+\.[html|jpeg|jpg|gif|png]/i,
  FALLBACK_SOURCE_LOCALE: 'en',
  SOURCE_FILE_REGEXP: /\/[\w-]+\.(?:html|jpg|jpeg|png)/i,
  LOCALE_TO_TRIM_REGEXP: /\/\w{2}(?:-\w{2})?(\/[\w-]+\.(?:jpg|jpeg|html))/i,
  HOME_PAGE_PATH_REGEXP: /^\/(\w{2}(?:-\w{2})?)(?:\/)?$/i,
  MIN_LOCALES_BEFORE_REMOVAL_FOR_MONOLINGUAL_SITE: 2,
  DEFAULT_SITE_LOCALE: 'en',
};
